import React from "react";
import IIntakeForm from "../../../models/IIntakeForm";
import OwButton from "../../shared/OwButton/OwButton";
import OwTitle from "../../shared/OwTitle/OwTitle";
import UIService from "../../../services/UIService";

type Props = {
    form: IIntakeForm;
    closeFn: () => void;
};

export const IntakeFormSetupModal = (props: Props) => {
    const mainViewLight = UIService.isMainViewLight();

    return (
        <div className={"IntakeFormSetupModal"}>
            <div className={"d-flex justify-content-between align-items-center"}>
                <OwTitle title={"form_setup"} tag={"h3"} />
                <div>
                    <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={props.closeFn} />
                </div>
            </div>

            <div className={"mt-4"}>
                <b>Send across the following fields:</b>
                <table className={"table " + (mainViewLight ? "" : "table-dark")}>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Field Name</th>
                            <th>Expected Value / Type</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                            <td>Form GUID</td>
                            <td>formGuid</td>
                            <td>{props.form.guid}</td>
                        </tr>
                        <tr>
                            <td>Name</td>
                            <td>name</td>
                            <td>String of persons name</td>
                        </tr>
                        <tr>
                            <td>Email</td>
                            <td>email</td>
                            <td>String of persons email</td>
                        </tr>
                        <tr>
                            <td>Company Name</td>
                            <td>company_name</td>
                            <td>String of company to setup</td>
                        </tr>
                        <tr>
                            <td>Company Email</td>
                            <td>company_email</td>
                            <td>String of company&#39;s email</td>
                        </tr>
                    </tbody>
                </table>

                {props.form.Intake_Form_Fields?.length ? (
                    <div>
                        <b>This form also has the following additional fields:</b>
                        <table className={"table " + (mainViewLight ? "" : "table-dark")}>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Field Name</th>
                                    <th>Expected Value / Type</th>
                                </tr>
                            </thead>

                            <tbody>
                                {props.form.Intake_Form_Fields.map((field) => {
                                    return (
                                        <tr key={field.name}>
                                            <td>{field.name}</td>
                                            <td>{field.name}</td>
                                            <td>String data for field</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                ) : null}

                <div className={"mt-4"}>
                    <b>The url you will need to send the form to:</b>
                    <div>
                        <span>https://owapi.orderwerks.com/v1/account_intake_form</span>
                    </div>
                </div>

                <div className="mt-4">Contact support for assistance or any questions.</div>
            </div>
        </div>
    );
};
